import { List } from "@mui/material";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarMenuItems } from "./SidebarMenuItems";
import { getMenuItems } from "@/data/menu";
import { useAuthStore } from "@/contexts/useAuthStore";

interface SidebarMenuProps {
  onMenuItemClick?: () => void;
}
export const SidebarMenu = ({ onMenuItemClick }: SidebarMenuProps) => {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});
  const [selectedItem, setSelectedItem] = useState("");
  const { logout, user } = useAuthStore();
  const handleLogout = logout;

  // Get dynamic menu items based on user authentication and role
  const menuItems = useMemo(() => getMenuItems(user), [user]);

  return (
    <List
      sx={{
        width: "100%",
        py: 1,
        px: 0.5,
      }}
    >
      <SidebarMenuItems
        items={menuItems}
        openItems={openItems}
        setOpenItems={setOpenItems}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        handleLogout={handleLogout}
        navigate={(path: string) => {
          setSelectedItem(
            menuItems.find((item) => item.path === path)?.text || ""
          );
          navigate(path);
        }}
        onMenuItemClick={onMenuItemClick}
      />
    </List>
  );
};
